import { CAD_FILE_EXTENSIONS } from "./CAD_FILE_EXTENSIONS";

export const ACCEPTED_ELEMENT_EXTENSIONS = [
  ...CAD_FILE_EXTENSIONS,
  "jpg",
  "jpeg",
  "png",
  "pdf",
];
